import { parseApiError } from "./lib/parseApiError";

/**
 * Извлекает человекочитаемое сообщение из ошибки.
 * Делегирует в parseApiError (§18.4) для единообразной обработки.
 */
export const extractErrorMessage = (err: unknown): string => parseApiError(err).message;
